export const SL_DELIVERY_TITLE = 'session.lock.delivery_title';
export const SL_PICKUP_ZIP_TITLE = 'session.lock.pickup_zip_title';
export const SL_PICKUP_STORE_TITLE = 'session.lock.pickup_store_title';
export const SL_RESET = 'session.lock.reset';
